import { makeStyles } from 'tss-react/mui';

import { bsBlue } from 'constants/colors';

export const useStyles = makeStyles()(() => {
  return {
    wrapper: {
      position: 'relative',
      overflow: 'hidden',
      '& > div': {
        maxWidth: '100%',
        maxHeight: '100%',
      },
      '& video': {
        objectFit: 'contain',
        clipPath: 'inset(1px 1px)',
      },
      '& .controls': {
        opacity: 0,
        transform: 'translateY(100%)',
        transition: 'transform 0.5s, opacity 0.5s',
      },
      '&:hover, &.isFullscreen:not(.onPage)': {
        '& .controls': {
          opacity: 1,
          transform: 'translateY(0)',
        },
      },
      '&.isFullscreen:not(.onPage)': {
        overflow: 'visible',
        '& .controls': {
          // bottom: -40,
          bottom: 0,
        },
        '& > .ReactPlayer': {
          width: '100%!important',
          height: '100%!important',
        },
        '& video': {
          paddingBottom: 86,
        },
      },
      '&.onPage': {
        '& .controls': {},
      },
      '& > .ReactPlayer': {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    fullHeight: { height: '100%' },
    controls: {
      background: 'rgba(51, 51, 51, .5)',
      padding: '15px 16px',
      height: 70,
      position: 'absolute',
      width: '100%',
      bottom: 0,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,

      '& svg': {
        color: '#FFFFFF',
      },
    },
    durationWrapper: {
      width: 'auto!important',
      whiteSpace: 'nowrap',
    },
    controlDuration: {
      color: '#FFFFFF',
      '& span': {
        fontVariantNumeric: 'tabular-nums',
      },
    },
    controlSeek: {
      position: 'relative',
      margin: '0 32px',
      flexGrow: 1,
      height: 3,
      backgroundColor: bsBlue,
      width: '100%',

      '&::-webkit-progress-value': {
        background: bsBlue,
      },

      '&.preview': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 4,
        margin: 0,
      },
    },
    playStopBtn: {
      // background:
      position: 'absolute',
      right: 0,
      bottom: 0,
      '& svg': {
        width: 35,
        height: 35,
        color: '#BDBDBD',
      },
      '&:hover': {
        '& svg': {
          color: '#828282',
        },
      },
    },
  };
});
